var iframe = document.getElementById('paymetricIFrame');
class PaymentIframePoc {

    Init() {
        var inst = this;
        $('#submit-payment').click(function (event) {
            event.preventDefault();
            inst.paynow();
        });
    }

    paynow() {
        $XIFrame.validate({
            iFrameId: 'paymetricIFrame',
            targetUrl: iframe.getAttribute("src"),
            autosizeheight: true,
            autosizewidth: true,
            onValidate: function (e) {
                if (e) {
                    $XIFrame.submit({
                        iFrameId: 'paymetricIFrame',
                        targetUrl: iframe.getAttribute("src"),
                        onSuccess: function (msg) {
                            var message = JSON.parse(msg);
                            if (message && message.data.HasPassed) {
                                var accessToken = document.getElementById('hdnAccessToken');
                                var signedToken = document.getElementById('hdnSignedToken');
                                window.location = "success?id=" + accessToken.value + "&s=" + signedToken.value;
                            } else {
                                alert(message.data.Message);
                            }
                        },
                        onError: function (msg) {
                            alert("Error function : " + msg);
                        }
                    });
                } else {
                    console.log(e);
                }
            }
        });
    }
}

$(document).ready(function () {
    var payment = new PaymentIframePoc();
    payment.Init();

});

